import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { GetLinkedZoomAccountViewModel } from 'edu-application/dist/zoom-tokens/get-linked-zoom-accounts/get-linked-zoom-accounts.viewmodel';
import { SettingsService } from '../settings.service';
import { GetSystemConfigViewModel } from 'edu-application/dist/system-config/get-system-config/get-system-config.veiwmodel';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'edu-zoom-integration',
  templateUrl: './zoom-integration.component.html',
  styleUrl: './zoom-integration.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ZoomIntegrationComponent implements OnInit {
  linkedZoomAccounts: GetLinkedZoomAccountViewModel[] = [];
  loading = true;
  @Input() orgId!: string;
  @Input() systemConfig: GetSystemConfigViewModel | null = null;

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.loadLinkedAccounts();
  }

  loadLinkedAccounts(): void {
    this.loading = true;
    this.settingsService.getAllLinkedZoomAccounts().subscribe({
      next: (accounts) => {
        this.linkedZoomAccounts = accounts || [];
        this.loading = false;
      },
      error: () => {
        this.linkedZoomAccounts = [];
        this.loading = false;
      },
    });
  }

  // If there's a linked account and the config doesn't have a zoomEmail yet
  // (or it differs), sync the first account's email to the system config
  private syncZoomEmailToConfig(): void {
    const firstAccount = this.linkedZoomAccounts[0];
    if (!firstAccount) return;

    const alreadySynced =
      this.systemConfig?.zoomEmail === firstAccount.zoomEmail;
    if (alreadySynced) return;

    this.settingsService
      .upsertSystemConfig(this.orgId, {
        zoomEmail: firstAccount.zoomEmail,
      })
      .subscribe();
  }

  linkZoomAccount(): void {
    const clientId = 'GxzwyCF5Q6GxnEDs4mub7Q';
    const redirectUri = `${environment.redirect_uri}/portal/settings/zoom-callback`;
    const zoomAuthUrl = `https://zoom.us/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}`;
    window.location.href = zoomAuthUrl;
  }
}
